export interface InGame {
  showInGameInfo: boolean;
  showInGameTeams: boolean;
  showInGameCreateTeams: boolean;
  showInGameJoinLeaveTeams: boolean;
  showInGameInventory: boolean;
  showInGameRoles: boolean;
  showInGameScoreboard: boolean;
  showInGamePlayerTeamScore: boolean;
  showInGameLeaderboard: boolean;
  showInGameChat: boolean;
  showInGameFacilitatorChat: boolean;
  showInGameAllPlayerChat: boolean;
  showInGameDirectChat: boolean;
  showInGameTeamChat: boolean;
  showInGameGroupChat: boolean;
  showInGameTrade: boolean;
  tasksRequireProximity: boolean;
  setTaskProximity?: string;
  enablePremessageOutsideRange: boolean;
  showOtherPlayerOrTeamOnMap: boolean;
  showPlayerScoreOnMap: boolean;
  showPlayerDetailByClickOnMap: boolean;
  showInGameOnDemandTask: boolean;
  enableInGameChangePlayerName: boolean;
}

export const DefaultInGame: InGame = {
  showInGameInfo: true,
  showInGameTeams: false,
  showInGameCreateTeams: false,
  showInGameJoinLeaveTeams: false,
  showInGameInventory: false,
  showInGameRoles: false,
  showInGameScoreboard: false,
  showInGamePlayerTeamScore: false,
  showInGameLeaderboard: false,
  showInGameChat: true,
  showInGameFacilitatorChat: true,
  showInGameAllPlayerChat: false,
  showInGameDirectChat: false,
  showInGameTeamChat: false,
  showInGameGroupChat: false,
  showInGameTrade: false,
  tasksRequireProximity: true,
  setTaskProximity: '0',
  enablePremessageOutsideRange: true,
  showOtherPlayerOrTeamOnMap: false,
  showPlayerScoreOnMap: false,
  showPlayerDetailByClickOnMap: true,
  showInGameOnDemandTask: false,
  enableInGameChangePlayerName: false
};
